import React from "react";
import { View, TouchableOpacity, Text } from "react-native";
import { Filter } from "lucide-react-native";
import { menuStyles } from "../styles/menuStyles";
import { FlickOColors } from "../styles/color";
import { registrationStyles as styles } from "../styles/registrationStyles";

interface QuickFiltersProps {
  selectedTypes: ("veg" | "egg" | "non-veg")[];
  onToggleType: (type: "veg" | "egg" | "non-veg") => void;
  onMoreFilters: () => void;
}

// src/screens/tabs/Menu/components/MenuFilters/QuickFilters.tsx
export const QuickFilters: React.FC<QuickFiltersProps> = ({
  selectedTypes,
  onToggleType,
  onMoreFilters,
}) => {
  return (
    <View style={menuStyles.quickFiltersContainer}>
      <View style={styles.foodTypeButtons}>
        {["veg", "egg", "non-veg"].map((type) => (
          <TouchableOpacity
            key={type}
            style={[
              styles.foodTypeButton,
              selectedTypes.includes(type) && styles.selectedFoodType,
            ]}
            onPress={() => onToggleType(type as "veg" | "egg" | "non-veg")}
          >
            <View
              style={[
                styles.foodTypeIcon,
                type === "veg" && styles.vegIcon,
                type === "egg" && styles.eggIcon,
                type === "non-veg" && styles.nonVegIcon,
              ]}
            >
              {type === "egg" ? (
                <Text style={styles.eggText}>🥚</Text>
              ) : (
                <View
                  style={[
                    styles.innerDot,
                    {
                      backgroundColor:
                        type === "veg"
                          ? styles.vegIcon.borderColor
                          : styles.nonVegIcon.borderColor,
                    },
                  ]}
                />
              )}
            </View>
            <Text style={styles.foodTypeText}>
              {type.charAt(0).toUpperCase() + type.slice(1)}
            </Text>
          </TouchableOpacity>
        ))}
      </View>
    </View>
  );
};
